import { FC } from 'react';

import { IconProps } from './Icon.interfaces';
import StyledIcon from './Icon.styles';

const Icon: FC<IconProps> = ({ icon }) => <StyledIcon>{icon}</StyledIcon>;

export default Icon;
